document.addEventListener('DOMContentLoaded', () => {

    // 1. Listen globally for clicks during the capturing phase
    document.addEventListener('click', function (e) {
        
        // 2. Check if the clicked element (or its closest parent) is the checkout button
        const checkoutButton = e.target.closest('[name="checkout"]');
        if (!checkoutButton) return;

        // 3. Query the DOM for whichever date input is currently rendered
        const dateField = 
            document.querySelector('#payment_date_page') || 
            document.querySelector('#payment_date_drawer');

        // 4. If the field isn't present (e.g. standard B2C customer), let checkout pass
        if (!dateField) return;

        // 5. If the trade field is present but empty, halt the pipeline immediately
        if (!dateField.value) {
            e.preventDefault();
            e.stopImmediatePropagation(); // Kills Shopify's theme scripts from executing redirects

            alert('Please select your Expected Payment Date.');
            
            // Bring attention to the empty input field
            dateField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            dateField.focus();
        }
    }, true); // Crucial: 'true' turns on event capturing to intercept theme scripts early

});